/*
 *
 * TransactionDetailsNotePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 06-Jun-2025
*/
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import './TransactionDetailsNotePopup.scss'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import PortalTextInput from '@nexidigital/portaltextinput'
import { useIntl } from 'react-intl'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const TransactionDetailsNotePopup = (props) => {
  const intl = useIntl()

  const NOTE = 'note'
  const isUpdate = Boolean(props.authorizedTransactionDetailsNote.note)
  const initialValues = {
    [NOTE]: props.authorizedTransactionDetailsNote.note || ''
  }
  const validationMessages = {
    requiredError: intl.formatMessage(formattedMessage.requiredError.props)
  }
  const validationSchema = Yup.object().shape({
    [NOTE]: isUpdate ? Yup.string() : Yup.string().required(validationMessages.requiredError)
  })

  const handleSubmit = (values) => {
    props.actions.doEditAuthorizedTransactionDetailsNote({
      data: {
        serviceType: props.transactionContext.serviceType,
        terminalCode: props.transactionContext.terminalCode,
        transactionDateTime: props.transactionContext.transactionDateTime,
        transactionId: props.transactionContext.transactionId,
        authorizationCode: props.transactionContext.authorizationCode,
        note: values.note
      }
    })
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
    validateOnChange: false
  })

  const [isNoteFocused, setIsNoteFocused] = useState(false)

  const onTextNoteChangeHandler = (event, fieldName) => {
    formik.setFieldValue(fieldName, event.target.value)
  }

  const shouldShowError = !isUpdate && formik.touched[NOTE] && !isNoteFocused && Boolean(formik.errors[NOTE])
  return (
    <Toggle>
      <MerchantModal
        primaryButtonLoading={props.isLoading}
        title={formattedMessage.title}
        description={formattedMessage.description}
        ariaModalDescription={formattedMessage.description}
        onClose={() => props.actions.doHidePopup()}
        primaryAction={() => formik.handleSubmit()}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
        closeLabel={formattedMessage.close}
        topBarTitle=' '
      >
        <MerchantGenericCard
          title={formattedMessage.titleGenericCard}
          subtitle={formattedMessage.descriptionGenericCard}
        >
          <div>
            <PortalTextInput
              id={NOTE}
              name={NOTE}
              label={formattedMessage.labelPortalText}
              placeholder={intl.formatMessage({ id: 't.app.transactions.DetailsNotes.placeholderPortaLink' })}
              analyticsLabel={intl.formatMessage({ id: 't.app.transactions.DetailsNotes.transactionModifyNoteSubKeyword' })}
              type='text'
              value={formik.values[NOTE]}
              onChange={(e) => onTextNoteChangeHandler(e, NOTE)}
              onFocus={() => setIsNoteFocused(true)}
              onBlur={(e) => {
                formik.handleBlur(e)
                setIsNoteFocused(false)
              }}
              error={shouldShowError}
              errorText={shouldShowError && formik.errors[NOTE]}
              maxLength={300}
              helperText={`${300 - formik.values[NOTE].length} ${intl.formatMessage({ id: 't.app.transactions.DetailsNotes.countChart' })}`}
              multiline
            />
          </div>
        </MerchantGenericCard>
      </MerchantModal>
    </Toggle>
  )
}

TransactionDetailsNotePopup.propTypes = {
  actions: PropTypes.object,
  isLoading: PropTypes.bool,
  authorizedTransactionDetailsNote: PropTypes.object,
  transactionContext: PropTypes.object
}

TransactionDetailsNotePopup.defaultProps = {
  actions: {},
  isLoading: false,
  authorizedTransactionDetailsNote: {},
  transactionContext: {}
}

export default TransactionDetailsNotePopup
